'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module3Act1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, profile: state.profile.data, app: state.moduleData.data.module3.act1 };
}, (0, _extends3.default)({}, moduleActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Act1, _Component);

  function Module3Act1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Act1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Act1.__proto__ || (0, _getPrototypeOf2.default)(Module3Act1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 1,
      title: 'Strategies to encourage children to eat fruit and vegetables',
      isCompleted: false,
      activities: [{
        activity: 'Try using the P\'s and C\'s framework',
        checked: _this.props.app.item1 || false
      }, {
        activity: 'Educate your child in simple words the benefits of vegetables (Eg. vegetables help to give you energy so you can run really fast at soccer',
        checked: _this.props.app.item2 || false
      }, {
        activity: 'Keep serving it up! Repeatedly serve, keep providing and give exposure to vegies',
        checked: _this.props.app.item3 || false
      }, {
        activity: 'Keep positive, positive language, avoid anger',
        checked: _this.props.app.item4 || false
      }, {
        activity: 'Role model - eat vegies myself/eat vegies in front of them',
        checked: _this.props.app.item5 || false
      }, {
        activity: 'Make vegetables interesting/appealing/fun eg. Spiralled vegies or vegie faces',
        checked: _this.props.app.item6 || false
      }, {
        activity: 'Offer a variety of vegetables',
        checked: _this.props.app.item7 || false
      }, {
        activity: 'Add a sauce or additional flavour to vegies',
        checked: _this.props.app.item8 || false
      }, {
        activity: 'Mix in/disguise vegies and provide a sample of the vegie (that was mixed in) on your child\'s plate',
        checked: _this.props.app.item9 || false
      }, {
        activity: 'Try a new vegie this week and put it on the plate next to the ones your child likes',
        checked: _this.props.app.item10 || false
      }, {
        activity: 'Give them meals/vegies that they like',
        checked: _this.props.app.item11 || false
      }, {
        activity: 'Involve your child in food decisions',
        checked: _this.props.app.item12 || false
      }, {
        activity: 'Avoid using rewards like dessert or lollies',
        checked: _this.props.app.item13 || false
      }, {
        activity: 'Avoid using food as a punishment (better to remove an activity as a punishment eg. TV)',
        checked: _this.props.app.item14 || false
      }, {
        activity: 'Don\'t pressure child to eat or make child finish food or not let child leave table until all eaten',
        checked: _this.props.app.item15 || false
      }]
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      var flatObj = {};
      flatObj['isCompleted'] = _this.state.isCompleted;
      var iter = 0;
      for (iter = 0; iter < _this.state.activities.length; iter++) {
        var temp = iter + 1;
        var str = 'item' + temp;
        flatObj[str] = _this.state.activities[iter].checked;
      }

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, flatObj);
    }, _this.handleChange = function (index, event) {
      var obj = _this.state;
      obj.activities[index].checked = !obj.activities[index].checked;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * General function used to change state of object
   */


  (0, _createClass3.default)(Module3Act1, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Select the strategies you would like to try this week or come up with some of your own!'
              ),
              this.state.activities.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: 'activity' + index },
                  _react2.default.createElement(
                    ReactBootstrap.Checkbox,
                    { onChange: _this2.handleChange.bind(_this2, index), checked: item.checked },
                    item.activity
                  ),
                  ' '
                );
              }),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  '(Your selections will update once you logout.)'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Module3Act1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModuleAct: _propTypes2.default.func
}, _temp2)) || _class);

/* eslint-enable */

exports.default = Module3Act1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Activities/Act1.js
// module id = 1195
// module chunks = 0